/**
 * @fileoverview Jobs Route Group
 *
 * Purpose: Layout wrapper for all job-related routes.
 * URL: /dashboard/jobs/*
 * Protection: Requires authentication (via parent _auth route)
 *
 * Wraps: /dashboard/jobs, /dashboard/jobs/:jobId/*
 */

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_auth/dashboard/_layout/jobs")({
  component: JobsLayout,
  beforeLoad: () => ({
    headerTitle: "Jobs",
  }),
});

function JobsLayout() {
  return <Outlet />;
}
